/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "#client";
import type { Client, RequestConfig, ResponseErrorConfig } from "#client";
import type {
	UserCheckPhoneResendCreateData,
	UserCheckPhoneResendCreateStatus200,
	UserCheckPhoneResendCreateStatus400,
	UserCheckPhoneResendCreateStatus503,
} from "../types/UserCheckPhoneResendCreate.ts";

function getUserCheckPhoneResendCreateUrl() {
	const res = { method: "POST", url: `/api/user/check-phone/resend/` as const };

	return res;
}

/**
 * @description Повторный запрос ОТП-кода.
 * @summary повторный запрос ОТП
 * {@link /api/user/check-phone/resend/}
 */
export async function userCheckPhoneResendCreate(
	data: UserCheckPhoneResendCreateData,
	config: Partial<RequestConfig<UserCheckPhoneResendCreateData>> & { client?: Client; contentType?: "application/json" | "application/xml" } = {},
) {
	const { client: request = client, contentType = "application/json", ...requestConfig } = config;

	const requestData = data;

	const res = await request<
		UserCheckPhoneResendCreateStatus200,
		ResponseErrorConfig<UserCheckPhoneResendCreateStatus400 | UserCheckPhoneResendCreateStatus503>,
		UserCheckPhoneResendCreateData
	>({ method: "POST", url: getUserCheckPhoneResendCreateUrl().url.toString(), data: requestData, contentType, ...requestConfig });

	return res.data;
}
